import React from "react";
import { CurrentStageHeader } from "../../Components/CurrentStageHeader";
import { IStage } from "../../Models/IStage";
import { List } from "../../Components/Fields/List";
import { TrainingListModal } from "./TrainingListModal";
import { Formatting } from "../../Helpers/Formatting";
import { ITrainingEntry } from "../../Models/ApplicationFormData";

/** Description of the "Further Training / Professional Memberships" stage */
export const TrainingPart1TrainingHistory: IStage = {
    title: "Further training/professional memberships",
    uniqueStageName: "Training (Part 1; Training History)",
    className: "training-stage",
    fieldNames: ["training"],

    /** Component representing the "Further Training / Professional Memberships" stage */
    component: function TrainingPart1TrainingHistory(): JSX.Element {
        return (
            <>
                <CurrentStageHeader />
                <p className="instruction">
                    Please include diplomas, certificates, class of membership, awards achieved etc.
                </p>
                <List<ITrainingEntry>
                    fieldName="training"
                    modalProps={TrainingListModal()}
                    getRowTitle={(row) => row.institutionName}
                    headings={[
                        {
                            name: "Name of institution",
                            fieldName: "institutionName",
                            renderField: (row) => <>{row.institutionName}</>,
                        },
                        {
                            name: "FT / PT",
                            fieldName: "isFullTime",
                            renderField: (row) => <>{row.isFullTime ? "Full time" : "Part time"}</>,
                        },
                        {
                            name: "From",
                            fieldName: "from",
                            renderField: (row) => <>{row.from && Formatting.toDateString(row.from)}</>,
                        },
                        {
                            name: "To",
                            fieldName: "to",
                            renderField: (row) => <>{row.to && Formatting.toDateString(row.to)}</>,
                        },
                        { name: "Details", fieldName: "details", renderField: (row) => <>{row.details}</> },
                    ]}
                />
            </>
        );
    },
};
